var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReopenHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916992 4.58333C0.916992 4.58333 0.972597 4.1941 2.58351 2.58319C4.19442 0.972272 6.80621 0.972272 8.41716 2.58319C8.98788 3.15393 9.35642 3.85033 9.52275 4.58333M3.66699 4.58333H0.916992V1.83333M10.0837 6.41667C10.0837 6.41667 10.0281 6.80588 8.41716 8.41683C6.80621 10.0277 4.19442 10.0277 2.58351 8.41683C2.01276 7.84607 1.64423 7.14968 1.47791 6.41667M7.33366 6.41667H10.0837V9.16667",
    stroke: "#D97706",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReopenHistory);
export default __webpack_public_path__ + "static/media/reopen_history.6dce433cdb4edd7dca32152ff41ebac7.svg";
export { ForwardRef as ReactComponent };